import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
  name: 'dictionary',
})
export class DictionaryPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any, ...args: any): Observable<any> {
    return this.translate.get(value, args[0]);
  }
}
